import BaseService from './_base.service';

const URL = "/admin/user";

export const userService = {
    search,
    combo,
    page,
    pageFilter,
    one,
    create,
    edit,
    remove,
    removeLogic,
    login,
    recovery,
    logout,
    register,
    myinfo,
    editmyinfo,
    changepass,
    mysuscription
};

function search(offset,callback) {
    return BaseService.get(URL+"/all/", callback)
}

function combo(callback) {
    return BaseService.get(URL+"/combo/", callback, true)
}

function page(page,size,callback) {
    return BaseService.get(URL+"/search/"+page, callback, true)
}

function pageFilter(page,size,filter,callback) {
    return BaseService.post(URL+"/page/"+page+"/"+size, filter, callback, true)
}

function one(id,callback) {
    return BaseService.get(URL + "/one/"+id, callback);
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post(URL+"/", body, callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put(URL+"/"+id, body, callback, true)
}

function remove(id,callback) {
    return BaseService.delete(URL+"/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete(URL+"/"+id+"/logic", callback);
}

function login(user, callback) {
    let body = JSON.stringify(user)
    return BaseService.post("/login", body, callback, true)
}

function recovery(email, callback) {
    return BaseService.post("/recoverypass", email, callback, true)
}


function logout() {
    localStorage.removeItem('user');
}

function register(user, callback) {
    let body = JSON.stringify(user)
    return BaseService.post("/sign-up", body, callback, true)
}

function myinfo(callback) {
    return BaseService.get("/user/myinfo", callback)
}

function editmyinfo(user, callback) {
    let body = JSON.stringify(user)
    return BaseService.post("/user/editmyinfo", body, callback, true)
}

function changepass(passData, callback) {
    let body = JSON.stringify(passData)
    return BaseService.post("/user/changepass", body, callback, true)
}

function mysuscription(callback) {
    return BaseService.get("/user/mysuscription", callback)
}
